import http from './http'

// 获取列表
export function pageList (data) {
  return http.get('/user/app/regcode/pagelist?'+data)
}

// 批量生成激活码
export function batchBuild (data) {
  return http.post('/user/app/regcode/build/code', data)
}

export function getPrice () {
  return http.get('/client/user/activity/3051e8755ea84529a4e0f9caddb85419')
}
